var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bb-card appointments-list-card" },
    [
      _vm.subject.appointments && _vm.subject.appointments.length > 0
        ? _c("h5", [_vm._v(" " + _vm._s(_vm.appointmentsListTitle) + " ")])
        : _vm._e(),
      _vm.subject.appointments && _vm.subject.appointments.length > 0
        ? _c(
            "div",
            {
              staticClass: "appointments-list",
              staticStyle: { position: "relative" },
            },
            [
              _vm._l(_vm.displayedAppointments, function (appointment, key) {
                return _c(
                  "div",
                  { key: key, staticClass: "appointment-item mt-5 mb-5" },
                  [
                    _c("div", { staticClass: "d-flex" }, [
                      _c("div", { staticClass: "appointment-item-date" }, [
                        _c("span", { staticClass: "month-day" }, [
                          _vm._v(_vm._s(_vm.getMonthDay(appointment.date))),
                        ]),
                        _c("div", { staticClass: "weekday-month-container" }, [
                          _c("span", { staticClass: "weekday-string" }, [
                            _vm._v(_vm._s(_vm.getWeekday(appointment.date))),
                          ]),
                          _c("span", { staticClass: "month-string" }, [
                            _vm._v(_vm._s(_vm.getMonthName(appointment.date))),
                          ]),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "appointment-item-description" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "appointment-status",
                              class: _vm.getStatusClass(appointment.status),
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  appointment.status === "CANCELED"
                                    ? _vm.$t("appointmentList.status.canceled")
                                    : appointment.status === "FINISHED"
                                    ? _vm.$t("appointmentList.status.finished")
                                    : _vm.$t("appointmentList.status.active")
                                )
                              ),
                            ]
                          ),
                          _c("span", { staticClass: "appointment-service" }, [
                            _vm._v(_vm._s(appointment.service.name)),
                          ]),
                          _c("span", { staticClass: "appointment-time" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  appointment.from + " - " + appointment.to
                                ) +
                                " "
                            ),
                          ]),
                          _c(
                            "span",
                            { staticClass: "appointment-employee-title" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("calendar.appointment.employee"))
                              ),
                            ]
                          ),
                          _c("span", { staticClass: "appointment-employee" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  appointment.employee.first_name +
                                    " " +
                                    appointment.employee.last_name
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      ),
                      _c("div", [
                        _c("span", { staticClass: "appointment-item-price" }, [
                          _vm._v(_vm._s(appointment.service.price + " RSD")),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "appointment-break-row" }),
                    _c("br"),
                    appointment.status == "CANCELED" ||
                    appointment.status == "FINISHED"
                      ? _c("div", { staticClass: "event-action-buttons" })
                      : _c("div", { staticClass: "event-action-buttons" }, [
                          _c(
                            "button",
                            {
                              staticClass: "event-cancel-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.cancelAppointment(appointment)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "calendar.appointment.cancelAppointment"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "event-edit-btn",
                              on: {
                                click: function ($event) {
                                  return _vm.editAppointmentConcatenate(
                                    appointment
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "calendar.appointment.editAppointment"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]),
                  ]
                )
              }),
              !_vm.paginationDisabled
                ? _c("v-pagination", {
                    staticClass: "bb-pagination",
                    attrs: { length: _vm.pages.length },
                    model: {
                      value: _vm.page,
                      callback: function ($$v) {
                        _vm.page = $$v
                      },
                      expression: "page",
                    },
                  })
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm.subject.appointments && _vm.subject.appointments.length === 0
        ? _c("p", { staticClass: "no-appointments-text" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("appointmentList.noAppointmentsLabel")) + " "
            ),
          ])
        : _vm._e(),
      _c("CancelAppointmentModal", { ref: "cancelAppointmentModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }